import { useTranslation } from "@/hooks/useTranslation"
import { FileProtectOutlined } from "@/icons"
import { SectionFormTemplate } from "../SectionFormTemplate"
import { ConditionList } from "./components/ConditionList"

import { ConditionsSectionFormProps } from "."

const sectionId = "conditions-section-form"

export const ConditionsSectionForm = (props: ConditionsSectionFormProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "forms" })
  const {
    fieldName = "conditions",
    title = t("sections.conditions"),
    ...rest
  } = props

  return (
    <SectionFormTemplate
      id={sectionId}
      title={title}
      Icon={FileProtectOutlined}
    >
      <ConditionList fieldName={fieldName} {...rest} />
    </SectionFormTemplate>
  )
}

ConditionsSectionForm.sectionId = sectionId
